import { Typography } from '@mui/material';

import NavGroup from './NavGroup';
import menuItem from 'menu-items';

const filterMenuItems = (items, permissions) => {
  return items?.filter((item) => {
    if (item.children) {
      // ✅ Si el usuario tiene permiso para el grupo, se mantiene completo
      if (permissions.includes(item.title)) {
        return true;
      }

      // ✅ Si no, se filtran sus hijos individualmente
      item.children = filterMenuItems(item.children, permissions);
      return item.children.length > 0;
    }

    return permissions.includes(item.title);
  });
};

// const filterMenuItems = (items, permissions) => {
//   console.log('in filterMenuItems items--------------->', items);
//   console.log('in filterMenuItems permissions--------------->', permissions);
//   return items?.reduce((result, item) => {
//     if (item.children) {
//       // Recursively filter children
//       const filteredChildren = filterMenuItems(item.children, permissions);
//       // Include the collapse item if it or any of its children are in permissions
//       if (filteredChildren.length > 0 || permissions.includes(item.title)) {
//         result.push({ ...item, children: filteredChildren });
//       }
//     } else {
//       // Include the item if it's in permissions
//       if (permissions.includes(item.title)) {
//         result.push(item);
//       }
//     }
//     return result;
//   }, []);
// };

const getUserData = () => {
  const userData = localStorage.getItem('hotelData');
  return userData ? JSON.parse(userData) : null;
};

const MenuList = () => {
  const userData = getUserData();
  console.log('userData in MenuList  =>', userData);

  let navItems = [];

  if (userData) {
    console.log('in MenuList ===>', userData);

    const { role, permissions } = userData;

    console.log('role =>', role);
    console.log('permissions =>', permissions);

    if (role === 'admin') {
      navItems = menuItem?.navAdminItems?.map((item) => {
        switch (item.type) {
          case 'group':
            return <NavGroup key={item.id} item={item} />;
          default:
            return (
              <Typography key={item.id} variant="h6" color="error" align="center">
                Menu Items Error
              </Typography>
            );
        }
      });
    } else if (role === 'HotelAdmin') {
      navItems = menuItem?.navHotelAdminItems?.map((item) => {
        switch (item.type) {
          case 'group':
            return <NavGroup key={item.id} item={item} />;
          default:
            return (
              <Typography key={item.id} variant="h6" color="error" align="center">
                Menu Items Error
              </Typography>
            );
        }
      });
    } else {
      const filteredItems = filterMenuItems(menuItem.items, permissions);
      console.log('here is the selected filteredItems -------------------------->', filteredItems);

      navItems = filteredItems.map((item) => {
        switch (item.type) {
          case 'group':
            return <NavGroup key={item.id} item={item} />;
          case 'collapse':
            return <NavGroup key={item.id} item={item} />;
          default:
            return (
              <Typography key={item.id} variant="h6" color="error" align="center">
                Menu Items Error
              </Typography>
            );
        }
      });
    }
  }
  return <>{navItems}</>;
};
export default MenuList;
